/**
 *
 * constroi o objecto para ser enviado para a API.
 *
 * @param {String} model - ( user, client, etc )
 * @return {Function}
 *
*/
const builder = async ({ model, fields, helpers = {} }) => {
    const constructor = await import( /* webpackChunkName: 'model-[request]' */ `./${model}` )
        .then( request => request.create );

    const data = constructor( fields, helpers );
    return data;
};

/**
 *
 * Obtém os campos obrigatórios de cada modelo.
 *
 * @param {String}  model ( user, client, etc )
 * @return {Array} [ 'name' ]
 *
*/
const getRequiredFields = model => import(
    /* webpackChunkName: 'model-[request]' */ `./${model}`
).then( request => request.requiredFields );

/**
 *
 * validação dos campos obrigatórios.
 * importa os campos obrigatórios de cada modelo.
 * percorre o array dos campos obrigatórios a ver se os campos foram preenchidos
 *     caso não tenham é criado um objecto com os campos em falta.
 *     caso tenham não adiciona ao objecto.
 *
 * @param {String}  model ( user, client, etc )
 * @param {Array}   filledFields ( { name: 'Teste' } )
 * @return {Object} { name: true }
 *
*/
const valdationRequiredFields = async ( model, filledFields, isEdit ) => {
    const requiredFields = await getRequiredFields( model );

    // validação no filter
    // -- é validado se é uma edição ou adição.
    //    caso seja uma adição é validado se a key existe no formulário.
    //    caso seja uma edição é validado se a key esta vazio
    //        ou se o campo é obrigatório na edição e e se a key existe no formulário.
    return requiredFields
        .filter( ({ field, isRequiredOnEdit }) => (
            !isEdit && !filledFields[field] )
            || ( isEdit
                && ( filledFields[field] === '' || ( isRequiredOnEdit && !filledFields[field] ) )
            ) )
        .reduce( ( fields, current ) => {
            // transforma o array dos campos em falta num objecto,
            // de forma a ser mais fácil o tratamento desta informação nos componentes
            // reduce - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
            fields[current.field] = true;
            return fields;
        }, {});
};

export {
    builder,
    valdationRequiredFields,
    getRequiredFields
};